import * as ambassadorWixEventsV3TicketDefinition from './events-v3-ticket-definition-ticket-definitions-v-2.http.js';
import * as ambassadorWixEventsV3TicketDefinitionTypes from './events-v3-ticket-definition-ticket-definitions-v-2.types.js';
import * as ambassadorWixEventsV3TicketDefinitionUniversalTypes from './events-v3-ticket-definition-ticket-definitions-v-2.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createTicketDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.CreateTicketDefinitionRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.CreateTicketDefinitionRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.CreateTicketDefinitionResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.CreateTicketDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.createTicketDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ticket-definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTicketDefinition(): __PublicMethodMetaInfo<
  'PATCH',
  { ticketDefinitionId: string },
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.UpdateTicketDefinitionRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.UpdateTicketDefinitionRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.UpdateTicketDefinitionResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.UpdateTicketDefinitionResponse
> {
  const payload = { ticketDefinition: { id: ':ticketDefinitionId' } } as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.updateTicketDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/ticket-definitions/{ticketDefinition.id}',
    pathParams: { ticketDefinitionId: 'ticketDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTicketDefinition(): __PublicMethodMetaInfo<
  'GET',
  { ticketDefinitionId: string },
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.GetTicketDefinitionRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.GetTicketDefinitionRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.GetTicketDefinitionResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.GetTicketDefinitionResponse
> {
  const payload = { ticketDefinitionId: ':ticketDefinitionId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.getTicketDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/ticket-definitions/{ticketDefinitionId}',
    pathParams: { ticketDefinitionId: 'ticketDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTicketDefinition(): __PublicMethodMetaInfo<
  'DELETE',
  { ticketDefinitionId: string },
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.DeleteTicketDefinitionRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.DeleteTicketDefinitionRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.DeleteTicketDefinitionResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.DeleteTicketDefinitionResponse
> {
  const payload = { ticketDefinitionId: ':ticketDefinitionId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.deleteTicketDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/ticket-definitions/{ticketDefinitionId}',
    pathParams: { ticketDefinitionId: 'ticketDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function reorderTicketDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.ReorderTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.ReorderTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.ReorderTicketDefinitionsResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.ReorderTicketDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.reorderTicketDefinitions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ticket-definitions/reorder',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryTicketDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.QueryTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.QueryTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.QueryTicketDefinitionsResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.QueryTicketDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.queryTicketDefinitions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ticket-definitions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAvailableTicketDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.QueryAvailableTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.QueryAvailableTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.QueryAvailableTicketDefinitionsResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.QueryAvailableTicketDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.queryAvailableTicketDefinitions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ticket-definitions/available/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countTicketDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.CountTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.CountTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.CountTicketDefinitionsResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.CountTicketDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.countTicketDefinitions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ticket-definitions/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countAvailableTicketDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.CountAvailableTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.CountAvailableTicketDefinitionsRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.CountAvailableTicketDefinitionsResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.CountAvailableTicketDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.countAvailableTicketDefinitions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ticket-definitions/available/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteTicketDefinitionsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.BulkDeleteTicketDefinitionsByFilterRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.BulkDeleteTicketDefinitionsByFilterRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.BulkDeleteTicketDefinitionsByFilterResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.BulkDeleteTicketDefinitionsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.bulkDeleteTicketDefinitionsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/ticket-definitions/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function changeCurrency(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.ChangeCurrencyRequest,
  ambassadorWixEventsV3TicketDefinitionTypes.ChangeCurrencyRequest,
  ambassadorWixEventsV3TicketDefinitionUniversalTypes.ChangeCurrencyResponse,
  ambassadorWixEventsV3TicketDefinitionTypes.ChangeCurrencyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3TicketDefinition.changeCurrency(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ticket-definitions/currency',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TicketDefinition as TicketDefinitionOriginal,
  SalePeriod as SalePeriodOriginal,
  PricingMethod as PricingMethodOriginal,
  PricingMethodPriceOneOf as PricingMethodPriceOneOfOriginal,
  CommonMoney as CommonMoneyOriginal,
  PricingOptions as PricingOptionsOriginal,
  OptionDetails as OptionDetailsOriginal,
  PricingTypeEnumType as PricingTypeEnumTypeOriginal,
  PricingTypeEnumTypeWithLiterals as PricingTypeEnumTypeWithLiteralsOriginal,
  FeeTypeEnumType as FeeTypeEnumTypeOriginal,
  FeeTypeEnumTypeWithLiterals as FeeTypeEnumTypeWithLiteralsOriginal,
  SaleStatusEnumStatus as SaleStatusEnumStatusOriginal,
  SaleStatusEnumStatusWithLiterals as SaleStatusEnumStatusWithLiteralsOriginal,
  SalesDetails as SalesDetailsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  EventDetails as EventDetailsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  CommonStreetAddress as CommonStreetAddressOriginal,
  CommonAddressLocation as CommonAddressLocationOriginal,
  CommonSubdivision as CommonSubdivisionOriginal,
  SubdivisionSubdivisionType as SubdivisionSubdivisionTypeOriginal,
  SubdivisionSubdivisionTypeWithLiterals as SubdivisionSubdivisionTypeWithLiteralsOriginal,
  DateAndTimeSettings as DateAndTimeSettingsOriginal,
  RecurrenceStatusStatus as RecurrenceStatusStatusOriginal,
  RecurrenceStatusStatusWithLiterals as RecurrenceStatusStatusWithLiteralsOriginal,
  Recurrences as RecurrencesOriginal,
  Occurrence as OccurrenceOriginal,
  Formatted as FormattedOriginal,
  PageUrl as PageUrlOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  SeatingDetails as SeatingDetailsOriginal,
  AvailablePlace as AvailablePlaceOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  SalePeriodUpdated as SalePeriodUpdatedOriginal,
  TicketDefinitionSaleStarted as TicketDefinitionSaleStartedOriginal,
  TicketDefinitionSaleEnded as TicketDefinitionSaleEndedOriginal,
  CreateTicketDefinitionRequest as CreateTicketDefinitionRequestOriginal,
  Field as FieldOriginal,
  FieldWithLiterals as FieldWithLiteralsOriginal,
  CreateTicketDefinitionResponse as CreateTicketDefinitionResponseOriginal,
  UpdateTicketDefinitionRequest as UpdateTicketDefinitionRequestOriginal,
  UpdateTicketDefinitionResponse as UpdateTicketDefinitionResponseOriginal,
  GetTicketDefinitionRequest as GetTicketDefinitionRequestOriginal,
  GetTicketDefinitionResponse as GetTicketDefinitionResponseOriginal,
  DeleteTicketDefinitionRequest as DeleteTicketDefinitionRequestOriginal,
  DeleteTicketDefinitionResponse as DeleteTicketDefinitionResponseOriginal,
  ReorderTicketDefinitionsRequest as ReorderTicketDefinitionsRequestOriginal,
  ReorderTicketDefinitionsRequestReferenceDefinitionOneOf as ReorderTicketDefinitionsRequestReferenceDefinitionOneOfOriginal,
  ReorderTicketDefinitionsResponse as ReorderTicketDefinitionsResponseOriginal,
  UpdateTicketDefinitionSortIndexRequest as UpdateTicketDefinitionSortIndexRequestOriginal,
  UpdateTicketDefinitionSortIndexResponse as UpdateTicketDefinitionSortIndexResponseOriginal,
  QueryTicketDefinitionsRequest as QueryTicketDefinitionsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryTicketDefinitionsResponse as QueryTicketDefinitionsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryAvailableTicketDefinitionsRequest as QueryAvailableTicketDefinitionsRequestOriginal,
  QueryAvailableTicketDefinitionsResponse as QueryAvailableTicketDefinitionsResponseOriginal,
  CountTicketDefinitionsRequest as CountTicketDefinitionsRequestOriginal,
  CountTicketDefinitionsResponse as CountTicketDefinitionsResponseOriginal,
  FacetCounts as FacetCountsOriginal,
  CountAvailableTicketDefinitionsRequest as CountAvailableTicketDefinitionsRequestOriginal,
  CountAvailableTicketDefinitionsResponse as CountAvailableTicketDefinitionsResponseOriginal,
  BulkDeleteTicketDefinitionsByFilterRequest as BulkDeleteTicketDefinitionsByFilterRequestOriginal,
  BulkDeleteTicketDefinitionsByFilterResponse as BulkDeleteTicketDefinitionsByFilterResponseOriginal,
  ChangeCurrencyRequest as ChangeCurrencyRequestOriginal,
  ChangeCurrencyResponse as ChangeCurrencyResponseOriginal,
  BulkCopyTicketDefinitionsByEventIdRequest as BulkCopyTicketDefinitionsByEventIdRequestOriginal,
  BulkCopyTicketDefinitionsByEventIdResponse as BulkCopyTicketDefinitionsByEventIdResponseOriginal,
  CopiedTicketDefinition as CopiedTicketDefinitionOriginal,
  UpdateFeeTypesBasedOnSettingsRequest as UpdateFeeTypesBasedOnSettingsRequestOriginal,
  UpdateFeeTypesBasedOnSettingsResponse as UpdateFeeTypesBasedOnSettingsResponseOriginal,
  EventDeleted as EventDeletedOriginal,
  Empty as EmptyOriginal,
  EventCanceled as EventCanceledOriginal,
  CancellationActor as CancellationActorOriginal,
  CancellationActorType as CancellationActorTypeOriginal,
  CancellationActorTypeWithLiterals as CancellationActorTypeWithLiteralsOriginal,
  EventEnded as EventEndedOriginal,
  EventCreated as EventCreatedOriginal,
  EventsLocation as EventsLocationOriginal,
  MapCoordinates as MapCoordinatesOriginal,
  LocationLocationType as LocationLocationTypeOriginal,
  LocationLocationTypeWithLiterals as LocationLocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  ScheduleConfig as ScheduleConfigOriginal,
  EventsRecurrences as EventsRecurrencesOriginal,
  EventsOccurrence as EventsOccurrenceOriginal,
  EventsRecurrenceStatusStatus as EventsRecurrenceStatusStatusOriginal,
  EventsRecurrenceStatusStatusWithLiterals as EventsRecurrenceStatusStatusWithLiteralsOriginal,
  EventStatus as EventStatusOriginal,
  EventStatusWithLiterals as EventStatusWithLiteralsOriginal,
  Event as EventOriginal,
  Scheduling as SchedulingOriginal,
  Image as ImageOriginal,
  Registration as RegistrationOriginal,
  EventType as EventTypeOriginal,
  EventTypeWithLiterals as EventTypeWithLiteralsOriginal,
  RegistrationStatus as RegistrationStatusOriginal,
  RegistrationStatusWithLiterals as RegistrationStatusWithLiteralsOriginal,
  RsvpCollection as RsvpCollectionOriginal,
  RsvpCollectionConfig as RsvpCollectionConfigOriginal,
  RsvpStatusOptions as RsvpStatusOptionsOriginal,
  RsvpStatusOptionsWithLiterals as RsvpStatusOptionsWithLiteralsOriginal,
  RsvpConfirmationMessages as RsvpConfirmationMessagesOriginal,
  RsvpConfirmationMessagesPositiveResponseConfirmation as RsvpConfirmationMessagesPositiveResponseConfirmationOriginal,
  RsvpConfirmationMessagesNegativeResponseConfirmation as RsvpConfirmationMessagesNegativeResponseConfirmationOriginal,
  Ticketing as TicketingOriginal,
  TicketingConfig as TicketingConfigOriginal,
  TaxConfig as TaxConfigOriginal,
  TaxType as TaxTypeOriginal,
  TaxTypeWithLiterals as TaxTypeWithLiteralsOriginal,
  TicketsConfirmationMessages as TicketsConfirmationMessagesOriginal,
  CheckoutType as CheckoutTypeOriginal,
  CheckoutTypeWithLiterals as CheckoutTypeWithLiteralsOriginal,
  Money as MoneyOriginal,
  ExternalEvent as ExternalEventOriginal,
  VisitorType as VisitorTypeOriginal,
  VisitorTypeWithLiterals as VisitorTypeWithLiteralsOriginal,
  CalendarLinks as CalendarLinksOriginal,
  SiteUrl as SiteUrlOriginal,
  Form as FormOriginal,
  InputControl as InputControlOriginal,
  InputControlType as InputControlTypeOriginal,
  InputControlTypeWithLiterals as InputControlTypeWithLiteralsOriginal,
  Input as InputOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  OptionSelection as OptionSelectionOriginal,
  OptionSelectionSelectedOptionOneOf as OptionSelectionSelectedOptionOneOfOriginal,
  Label as LabelOriginal,
  FormMessages as FormMessagesOriginal,
  RsvpFormMessages as RsvpFormMessagesOriginal,
  PositiveResponseConfirmation as PositiveResponseConfirmationOriginal,
  NegativeResponseConfirmation as NegativeResponseConfirmationOriginal,
  Positive as PositiveOriginal,
  Negative as NegativeOriginal,
  CheckoutFormMessages as CheckoutFormMessagesOriginal,
  ResponseConfirmation as ResponseConfirmationOriginal,
  RegistrationClosedMessages as RegistrationClosedMessagesOriginal,
  TicketsUnavailableMessages as TicketsUnavailableMessagesOriginal,
  Dashboard as DashboardOriginal,
  RsvpSummary as RsvpSummaryOriginal,
  TicketingSummary as TicketingSummaryOriginal,
  CancellationInfo as CancellationInfoOriginal,
  GuestListConfig as GuestListConfigOriginal,
  Feed as FeedOriginal,
  OnlineConferencing as OnlineConferencingOriginal,
  OnlineConferencingConfig as OnlineConferencingConfigOriginal,
  ConferenceType as ConferenceTypeOriginal,
  ConferenceTypeWithLiterals as ConferenceTypeWithLiteralsOriginal,
  OnlineConferencingSession as OnlineConferencingSessionOriginal,
  SeoSettings as SeoSettingsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  Agenda as AgendaOriginal,
  Category as CategoryOriginal,
  CategoryCounts as CategoryCountsOriginal,
  CategoryStateState as CategoryStateStateOriginal,
  CategoryStateStateWithLiterals as CategoryStateStateWithLiteralsOriginal,
  EventDisplaySettings as EventDisplaySettingsOriginal,
  LabellingSettings as LabellingSettingsOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  ImageDataCrop as ImageDataCropOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  SketchData as SketchDataOriginal,
  Variant as VariantOriginal,
  VariantWithLiterals as VariantWithLiteralsOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  CardStylesType as CardStylesTypeOriginal,
  CardStylesTypeWithLiterals as CardStylesTypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  BannerPosition as BannerPositionOriginal,
  BannerPositionWithLiterals as BannerPositionWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  CheckboxListData as CheckboxListDataOriginal,
  ListItemNodeData as ListItemNodeDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  Badge as BadgeOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  EventUpdated as EventUpdatedOriginal,
  SeatingPlanCategoriesSummaryUpdated as SeatingPlanCategoriesSummaryUpdatedOriginal,
  CategoryDetails as CategoryDetailsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  GetTicketDefinitionFromTrashBinRequest as GetTicketDefinitionFromTrashBinRequestOriginal,
  GetTicketDefinitionFromTrashBinResponse as GetTicketDefinitionFromTrashBinResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetTicketDefinitionSummaryRequest as GetTicketDefinitionSummaryRequestOriginal,
  GetTicketDefinitionSummaryResponse as GetTicketDefinitionSummaryResponseOriginal,
  TicketDefinitionSummary as TicketDefinitionSummaryOriginal,
  ListEventTicketingSummaryRequest as ListEventTicketingSummaryRequestOriginal,
  ListEventTicketingSummaryResponse as ListEventTicketingSummaryResponseOriginal,
  EventTicketingSummary as EventTicketingSummaryOriginal,
  UpdateEventTicketingSummaryRequest as UpdateEventTicketingSummaryRequestOriginal,
  UpdateEventTicketingSummaryResponse as UpdateEventTicketingSummaryResponseOriginal,
  CreateTicketDefinitionApplicationErrors as CreateTicketDefinitionApplicationErrorsOriginal,
  UpdateTicketDefinitionApplicationErrors as UpdateTicketDefinitionApplicationErrorsOriginal,
  ReorderTicketDefinitionsApplicationErrors as ReorderTicketDefinitionsApplicationErrorsOriginal,
  CountTicketDefinitionsApplicationErrors as CountTicketDefinitionsApplicationErrorsOriginal,
  CountAvailableTicketDefinitionsApplicationErrors as CountAvailableTicketDefinitionsApplicationErrorsOriginal,
  ChangeCurrencyApplicationErrors as ChangeCurrencyApplicationErrorsOriginal,
} from './events-v3-ticket-definition-ticket-definitions-v-2.types.js';
